import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Column, Divider, Row } from '~/commonComponents';
import { JobPostingStatus } from '~/domain/PermanentJobs';
import { AlertCircleIcon } from '~/images/icons';

interface IClosedBannerProps {
  hasScheduledOnsiteInterviews: boolean;
  jobStatus: JobPostingStatus;
}

export const ClosedBanner = ({ hasScheduledOnsiteInterviews, jobStatus }: IClosedBannerProps) => {
  if (jobStatus !== JobPostingStatus.Closed) {
    return null;
  }

  return (
    <Row
      data-cy="closed-job-banner"
      alignItems="center"
      backgroundColor={colors.neutral[50]}
      borderColor={colors.neutral[400]}
      borderRadius={6}
      borderStyle="solid"
      borderWidth={1}
      gap={12}
      marginTop={20}
      paddingBlock={12}
      paddingInline={10}
    >
      <AlertCircleIcon color={colors.neutral[400]} size={24} />
      <Divider height="95%" width={1} color={colors.neutral[400]} />
      <Column>
        <Typography as="span" bold color={colors.neutral[600]} style={{ marginBottom: 4 }}>
          This Job Posting Is Closed:
        </Typography>
        <Typography as="span" color={colors.neutral[600]}>
          {hasScheduledOnsiteInterviews ? (
            <>
              Candidates can no longer view or apply to this job. Any onsite interviews already
              scheduled within 7 days of the closing date will remain active. All others have been
              canceled.
            </>
          ) : (
            <>
              Candidates can no longer view or apply to this job. You can still view and review its
              details anytime, but no additional actions can be taken.
            </>
          )}
        </Typography>
      </Column>
    </Row>
  );
};
